export default __webpack_public_path__ + "static/media/total_cruzers@2x.a4188bed.png";